module.exports = __webpack_public_path__ + "img/prize-00.d4b58d86.png";